import { useFeatureFlagContext } from 'utils/hooks/context/useFeatureFlagContext'
import ForYouHomepage from '../components/ForYou/Homepage'
import ForYouHomepageRevamp from '../components/ForYou/HomepageRevamp'

type ForYouProps = {
  isDesktop?: boolean
  currentId?: string
}

const ForYou = ({ isDesktop, currentId }: ForYouProps) => {
  const { getFeatureByKey } = useFeatureFlagContext()
  const isEnablePelatihanMandiriRevamp = getFeatureByKey(
    'enablePelatihanMandiriRevamp'
  )

  return (
    <div>
      {isEnablePelatihanMandiriRevamp ? (
        <ForYouHomepageRevamp isDesktop={isDesktop} />
      ) : (
        <ForYouHomepage isDesktop={isDesktop} currentId={currentId} />
      )}
    </div>
  )
}

export default ForYou
